// URL patterns and link configurations
export const URL_PATTERNS = {
  PRODUCT_DETAIL: '/products/product-detail'
};

// Link targets
export const LINK_TARGETS = {
  BLANK: '_blank',
  SELF: '_self'
};

// Date formatting configurations
export const DATE_FORMATS = {
  DEFAULT: {
    showTime: false,
    separator: '/',
    format: 'mm-dd-yyyy'
  }
};

// Image display configurations
export const IMAGE_CONFIG = {
  GRID: {
    columns: 3,
    gap: 4
  },
  POSITION: {
    TEXT_PREFIX: 'Display Position '
  }
};

// Language display configurations
export const LANGUAGE_CONFIG = {
  FALLBACK_CODE: 'en',
  DISPLAY: {
    PREFIX: 'Language: ',
    GRID_COLUMNS: 3
  }
};
